import React from 'react';
import './HelportLogo.css';
import wordmarkSrc from '../LOGO.png';
import iconSrc from '../assets/helport-icon.svg';

const HelportLogo = ({
  variant = 'full',
  showTagline = false,
  className = '',
  onDark = true,
}) => {
  const rootClass = [
    'helport-logo',
    `helport-logo--${variant}`,
    onDark ? 'helport-logo--on-dark' : 'helport-logo--on-light',
    showTagline ? 'helport-logo--with-tagline' : '',
    className,
  ].filter(Boolean).join(' ');

  if (variant === 'icon') {
    return (
      <div className={rootClass}>
        <img src={iconSrc} alt="" className="helport-logo__icon" aria-hidden="true" />
      </div>
    );
  }

  if (variant === 'nav') {
    return (
      <div className={rootClass}>
        <img src={iconSrc} alt="" className="helport-logo__icon helport-logo__icon--nav" aria-hidden="true" />
        <div className="helport-logo__copy">
          <img src={wordmarkSrc} alt="Helport" className="helport-logo__wordmark helport-logo__wordmark--nav" />
          {showTagline && (
            <span className="helport-logo__tagline">Attendance Tracker</span>
          )}
        </div>
      </div>
    );
  }

  if (variant === 'form') {
    return (
      <div className={rootClass}>
        <img src={wordmarkSrc} alt="Helport" className="helport-logo__wordmark helport-logo__wordmark--form" />
        {showTagline && (
          <span className="helport-logo__tagline helport-logo__tagline--form">RFID Attendance System</span>
        )}
      </div>
    );
  }

  return (
    <div className={rootClass}>
      <img src={wordmarkSrc} alt="Helport" className="helport-logo__wordmark helport-logo__wordmark--hero" />
      {showTagline && (
        <span className="helport-logo__tagline helport-logo__tagline--hero">Workforce Attendance Platform</span>
      )}
    </div>
  );
};

export default HelportLogo;
